import _ from "underscore"
import TemplateView from "../TemplateView";
import LoadingControlMixin from "./LoadingControlMixin";

export default class MenuButton extends TemplateView {
    constructor({
        editable,
        positionParams = {offset: "0px 1px"},
        onShowMenu = () => {},
        onHideMenu = () => {},
    }) {
        super()
        this.editable = editable
        this.updateOnInit = false
        this.positionParams = positionParams

        this.onShowMenu = onShowMenu
        this.onHideMenu = onHideMenu
    }

    afterRender() {
        this.disabled = false;
        this.$el.toggleClass('editable', this.editable);
        this.bindClick(() => {
            if (!this.editable || this.disabled || this.isLoading())
                return;

            if (!this.getMenu().ignoreNextShowing)
                this.$el.addClass("pressed");
            this.onShowMenu()
            this.getMenu().showAt(this.$el, this.positionParams, (selectedValue) => {
                this._onSelect(selectedValue)
                this.onHideMenu()
            })
        });
    }

    update() {
        this.$el.toggleClass('editable', this.editable);
    }

    _onSelect(selectedValue) {
        this.$el.removeClass('pressed');
        if (this._change(selectedValue)) {
            this.update();
            this.trigger("change", selectedValue);
        }
    }

    /**
     * Get button actual menu instance
     * @returns menu {DropdownTemplateView}
     */
    getMenu() {
        //    abstract
    }

    /**
     * Change button data value
     * @param  selectedValue: new selected value in menu
     * @returns true if data was changed
     *          false otherwise
     */
    _change(selectedValue) {
        //    abstract
    }

    isDisabled() {
        return this.disabled;
    }

    setDisabled(disabled) {
        this.disabled = disabled;
        this.update();
    }

    disableAndHide() {
        this.setDisabled(true);
        this.getMenu().hide();
    }

    setEditable(editable) {
        this.editable = editable;
        this.update();
    }
}

_.extend(MenuButton.prototype, LoadingControlMixin);


// WEBPACK FOOTER //
// ./web/js/controls/MenuButton.js